export const messageTemplete={
    LOGIN_SUCCESS :"Logged In Successfully",
    SOMETHING_WENT_WRONG: "No active account found with the given credentials"


};